import { defineNuxtPlugin } from '#imports';
import { createI18n } from 'vue-i18n';
import en from '../lang/en.json';
import ja from '../lang/ja.json';

export default defineNuxtPlugin(({ vueApp }) => {
  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    // `window ? ...` は「window が常に truthy」なので 'ja' 側が死枝になり、
    // かつ window 自体が未定義の文脈では ReferenceError になる書き方だった。
    // 本アプリは nuxt.config.ts で ssr: false のため実害は出ていなかったが、
    // 存在判定は typeof で行うのが正しい。
    locale: typeof window !== 'undefined' ? window.navigator.language.split('-')[0] : 'ja',
    fallbackLocale: 'ja',
    messages: {
      en,
      ja,
    },
  });

  vueApp.use(i18n);
});
